import { Constants } from '../helpers/constants';

export class ReservationDailyRule {
	id: number;

	reservation_rule_id: number;

	day_of_week: 'sunday'|'monday'|'tuesday'|'wednesday'|'thursday'|'friday'|'saturday'|'sunday';
	max_people_per_reservation: number;
	threshold_modifier: number;
	schedules: string; // JSON string of schedulesObj

	created_at: string;
	updated_at: string;

	// set by our front end app
	auxSchedules: string;
	schedulesObj: {
		time: string // '21:00'
	}[];
	nDayOfWeek: number; // 0 is sunday, 6 is saturday

	static setAdditionalData(rdr: ReservationDailyRule) {
		if(rdr.schedules) {
			rdr.schedulesObj = JSON.parse(rdr.schedules);
			let schedulesStr = '';
			for(let schedule of rdr.schedulesObj) {
				schedulesStr += schedule.time.split(":").join("");
			}
			rdr.auxSchedules = schedulesStr;
		}

		rdr.nDayOfWeek = Constants.daysOfWeek.indexOf(rdr.day_of_week);
	}

	static setArrayAdditionalData(rdrs: ReservationDailyRule[]) {
		for(let rdr of rdrs) {
			ReservationDailyRule.setAdditionalData(rdr);
		}
	}

	static getCurrent(rdrs: ReservationDailyRule[], date: Date): ReservationDailyRule {
		for(let rdr of rdrs) {
			if(!rdr.nDayOfWeek)
				ReservationDailyRule.setAdditionalData(rdr);

			if(date.getDay() == rdr.nDayOfWeek)
				return rdr;
		}
	}

	static mountSchedulesStr(rdr: ReservationDailyRule) {
		rdr.schedulesObj = [];
		if(rdr.auxSchedules) {
			for(let i = 0; i < rdr.auxSchedules.length; i += 4) {
				rdr.schedulesObj.push({
					time: rdr.auxSchedules.substr(i, 2) + ':' + rdr.auxSchedules.substr(i + 2, 2)
				});
				rdr.schedules = JSON.stringify(rdr.schedulesObj);
			}
		}
	}
}